import { CroppingSuitabilityReportModel } from "@agroyaar/sdk";
import { ColumnChartData } from "@/shared/components/charts/ColumnChart";

type ReportKey =
  | "averageGrowingSeasonTemperature"
  | "totalRainfallDuringTheGrowingPeriod"
  | "degreeDayGrowingSeason"
  | "slopeLand"
  | "soilElectricalConductivity"
  | "soilAcidity"
  | "soilTexture"
  | "soilDepth"
  | "soilOrganicCarbon"
  | "waterSupplyIndex"
  | "finalLandSuitabilityIndex";

type ReportChartConfig = {
  key: ReportKey;
  label: string;
  yAxisTitle?: string;
};

export const reportChartConfigs: ReportChartConfig[] = [
  {
    key: "totalRainfallDuringTheGrowingPeriod",
    label: "مجموع بارندگی در طول دوره رشد",
    yAxisTitle: "شاخص تناسب (%)",
  },
  {
    key: "averageGrowingSeasonTemperature",
    label: "میانگین دما فصل رشد",
    yAxisTitle: "شاخص تناسب (%)",
  },
  {
    key: "degreeDayGrowingSeason",
    label: "درجه روز رشد فصل",
    yAxisTitle: "شاخص تناسب (%)",
  },
  {
    key: "soilElectricalConductivity",
    label: "هدایت الکتریکی خاک",
    yAxisTitle: "شاخص تناسب (%)",
  },
  { key: "soilAcidity", label: "اسیدیته خاک", yAxisTitle: "شاخص تناسب (%)" },
  { key: "soilTexture", label: "بافت خاک", yAxisTitle: "شاخص تناسب (%)" },
  {
    key: "soilOrganicCarbon",
    label: "کربن آلی خاک",
    yAxisTitle: "شاخص تناسب (%)",
  },
  { key: "slopeLand", label: "شیب زمین", yAxisTitle: "شاخص تناسب (%)" },
  { key: "soilDepth", label: "عمق خاک", yAxisTitle: "شاخص تناسب (%)" },
  {
    key: "waterSupplyIndex",
    label: "شاخص تأمین نیاز آبی",
    yAxisTitle: "شاخص تناسب (%)",
  },
];

export function mapIndexToChartData<T extends ReportKey>(
  reports: CroppingSuitabilityReportModel[],
  key: T
): ColumnChartData[] {
  return reports.map((r) => ({
    name: r.crop.persianName,
    value: r[key] ?? 0,
  }));
}
